<template>
  <div class="read_sentences">
    <precautions
      v-if="selectedStep === 0"
      :title="questionData.Name"
      :level="level"
      :unit="unit"
      :questionData="questionData"
    />

    <!-- start -->
    <div class="d-flex justify-content-center mt-3" v-if="selectedStep === 0">
      <a
        class="d-inline-block gept_main_bg4 text-white px-5 py-2 rounded-pill mx-auto pointer font-weight-bold"
        @click="start()"
      >
        START
      </a>
    </div>

    <!-- main -->
    <div v-if="selectedStep === 1" class="read_sentences_inner">
      <!-- header -->
      <div class="w-100 d-flex justify-content-between align-items-center bg-white mb-3 p-1">
        <div class="d-flex align-items-center">
          <p class="font-weight-bold gept_main_color p-2">
            Question {{ selectedIdx + 1 }}/{{ questionData.Questions.length }}
          </p>
        </div>
        <div
          class="p-2 p-md-3 rounded text-right border-1 border-4 gept_main_color4 border_main2 font-weight-bold"
        >
          {{ answer_count }} s
        </div>
      </div>

      <div class="pt-2 row">
        <!-- list -->
        <div class="order-2 order-md-1 px-2 px-md-0"
          :class="{ 'w-100 col-md-8': isReadingStatus }"
        >
          <div
            v-for="(item, index) in questionData.Questions"
            :key="index"
            class="w-100 d-flex flex-wrap flex-md-nowrap mb-3 bg-white rounded overflow-hidden"
          >
            <div
              class="gept_main_bg5 text-white text-center d-flex justify-content-center align-items-center w-16"
              :class="{
                gept_main_bg6: isCanActive && selectedIdx !== index,
                gept_main_bg5: isCanActive && selectedIdx === index
              }"
            >
              {{ arr[index] }}
            </div>

            <div class="flex-1 d-flex align-items-center">
              <div
                class="teacher_answer d-flex rounded overflow-hidden w-100"
                :class="{ pointer: isCanActive }"
              >
                <div class="flex-1 bg-white p-2 py-3">
                  <div class="bg-white mb-2 mx-auto">
                    <img
                      class="mx-auto d-block"
                      :src="item.ImageUrl"
                      alt=""
                    >
                  </div>
                  <p class="text-left"
                    :class="{
                      'gept_main_color8 pointer': isCanActive,
                      'text-dark font-weight-bold': isCanActive && selectedIdx === index
                    }"
                    v-html="item.Title.replace(/(?:\r\n|\r|\n)/g, '<br/>')"
                  ></p>
                </div>

                <div
                  class="bg-white d-flex align-items-center justify-content-center"
                  v-if="ERS_arr.length > 0"
                >
                  <img
                    src="@/assets/image/gept/icon_check.png"
                    class="mx-auto opacity-0"
                    :class="{ 'opacity-100': !isEmpty(ERS_arr[index]) }"
                    style="width: 50% !important;"
                  >
                </div>
              </div>
            </div>

            <!-- record -->
            <div class="record-scuare col-md-auto align-items-center justify-content-center border-top border-md-top-0 border-md-left border-4"
              :class="{ 'd-none': isReadingStatus, 'd-flex': !isReadingStatus }"
            >
              <div class="bg-white p-md-2 rounded w-100">
                <div
                  class="d-flex align-items-center justify-content-center"
                  v-if="!isNotEmpty(ERS_arr)"
                >
                  <RecognitionS
                    @emitAudioData="emitAudioData"
                    :itemIndex="index"
                    :selectedIdx="selectedIdx"
                    :isPostingRecord="isPostingRecord"
                    :isCanActive="isCanActive"
                  />
                </div>

                <div
                  class="pointer p-2"
                  v-if="isNotEmpty(ERS_arr)"
                  @click="setAudio(ERS_arr[index].audio)"
                >
                  <img
                    src="@/assets/image/gept/voice_play2.png"
                    class="mx-auto d-block"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- reading status -->
        <div class="w-100 col-4 item-outer border-left border-4 order-1 order-md-2 mb-2 mb-md-0" v-if="isReadingStatus">
          <div class="h-100 d-flex flex-column align-items-center justify-content-center item_border pointer bg-white"
          >
            <div>
              <div class="p-4 w-100 mb-4">
                <p class="font-weight-bold gept_main_color6 text-center">
                  回答
                </p>
              </div>

              <div class="item_img p-2 mb-2 justify-content-center d-none d-md-flex">
                <img
                  src="@/assets/image/gept/micro01_off.png"
                  class="mx-auto"
                >
              </div>

              <a
                @click="skipCountDown()"
                class="d-inline-block gept_main_bg5 text-white px-5 py-2 rounded mx-3 pointer font-weight-bold mb-4"
              >
                跳過倒數，開始作答
              </a>
            </div>

            <div class="p-4 w-100 d-flex align-items-center justify-content-center border-top border-4 border_main3"
            >
              <p
                class="gept_main_color6 text-center font-weight-bold"
                v-if="level === '初級'"
              >
                倒數60秒時，請先閱讀題目，<br>
                在時間內將全部朗讀完成。
              </p>
              <p
                class="gept_main_color6 text-center font-weight-bold"
                v-else
              >
                請先閱讀題目，閱讀時間結束倒數時，
                麥克風將會自動開啟錄音，請在時間內回答完成。
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- submit -->
      <div
        v-if="isNotEmpty(ERS_arr) || answer_count === 0"
        class="d-flex justify-content-center"
      >
        <a
          @click="toggleReport()"
          class="btn-default gept_main_bg5 text-white m-2 d-inline-block pointer"
        >
          {{ !isLastGroup && $route.name === 'formal_exam'
            ? '前往下一個題型'
            : '交卷看報告'
          }}
        </a>
      </div>
    </div>
  </div>
</template>


<script>
  // import api from '@/store/api'
  import precautions from '@/components/AiHelper/GEPT/precautions'
  import allJs from '@/components/AiHelper/all.js'
  import RecognitionS from '@/components/AiHelper/GEPT/RecognitionS'
  import formal_examJs from '@/components/AiHelper/examJs_gept.js'
  export default {
    name: 'read_sentences',

    data () {
      return {
        arr: ['ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN'],
        selectedStep: 0,

        selectedIdx: -1,

        isCanActive: false,
        isReadingStatus: true,

        isRecording: false,
        // 正在倒數中
        isCountingExam: false,

        answer_count: 60,
        timer: null,

        ERS_arr: [],
        sound_effect: null,

        isPostingRecord: false
      }
    },
    props: {
      questionData: {
        type: Object
      },
      unitTitle: {
        type: String
      },
      unit: {
        type: String
      },
      isLastGroup: {
        type: Boolean,
        default: false
      },
      level: {
        type: String
      },
      secondsData: {
        type: Object
      }
    },
    mixins: [
      allJs,
      formal_examJs
    ],
    components: {
      precautions,
      RecognitionS
    },
    computed: {
      sText () {
        let self = this
        if (self.selectedIdx > -1) {
          return self.questionData.Questions[self.selectedIdx].Title
        }
        return ''
      },
      testData () {
        let self = this
        if (localStorage.getItem(self.$route.params.select_id) && JSON.parse(localStorage.getItem(self.$route.params.select_id)).read_sentences) {
          return JSON.parse(localStorage.getItem(self.$route.params.select_id)).read_sentences
        }
        return []
      }
    },
    created () {
      this.answer_count = this.secondsData.preRead
    },
    beforeDestroy() {
      if (this.sound_effect) {
        this.audio_stop()
      }
    },
    mounted () {
      this.initErsArr()

      this.$emit('setIsStart', false)
    },
    methods: {
      start () {
        this.selectedStep = 1

        this.countDown()

        this.$emit('setIsStart', true)
      },

      initErsArr () {
        let self = this
        if (self.questionData) {
          let arrLength = self.questionData.Questions.length

          self.ERS_arr = new Array(arrLength).fill({})
        }
      },
      // step1
      countDown () {
        let self = this
        if (!self.isCanActive) {
          self.timer = setInterval(() => {
            self.answer_count--
            if (self.answer_count === 0) {
              self.isCanActive = true
              self.isReadingStatus = false
              clearInterval(self.timer)

              self.$nextTick(() => {
                self.answer_count = self.secondsData.exam
                self.startExam()
              })
            }
          }, 1000)
        } else {
          self.timer = setInterval(() => {
            self.answer_count--
            if (self.answer_count === 0) {
              self.isCanActive = false
              clearInterval(self.timer)
            }
          }, 1000)
        }

      },

      skipCountDown () {
        let self = this

        if (self.answer_count > 0 && self.timer && !self.isCanActive && self.isReadingStatus) {
          self.isCanActive = true
          self.isReadingStatus = false
          self.answer_count = self.secondsData.exam

          clearInterval(self.timer)

          self.$nextTick(() => {
            self.startExam()
          })
        }
      },

      startExam () {
        let self = this
        if (self.answer_count > 0 && self.isCanActive) {
          self.selectedIdx = 0

          self.answer_count = self.secondsData.exam

          self.$nextTick(() => {
            self.countDown()
          })
        }
      },

      selectItem (index) {
        let self = this
        if (self.answer_count > -1 && self.isCanActive && !self.ERS_arr[index].audio && !self.isRecording) {
          self.selectedIdx = index
          self.isRecording = true
        }
      },

      // step2
      async emitAudioData (emitAudioData) {
        let self = this
        self.isPostingRecord = true

        let result

        if (self.$route.name === 'practice_speaking') {
          result = await self.post_records_by_AIETA(self.$route.params.select_id, self.questionData.Questions[self.selectedIdx].Id, self.questionData.Name, self.questionData.Questions[self.selectedIdx].Title, emitAudioData)
        } else {
          result = await self.post_gept_records_byFormal(self.$route.query.record_id, self.questionData.Questions[self.selectedIdx].Id, self.questionData.Name, self.questionData.Questions[self.selectedIdx].Title, emitAudioData)
        }

        if (result) {
          self.ERS_arr[self.selectedIdx] = result
          self.isPostingRecord = false
          self.isRecording = false

          if (self.selectedIdx < self.questionData.Questions.length - 1) {
            self.selectItem(self.selectedIdx++)
          }
          if (self.isNotEmpty(self.ERS_arr)) {
            self.isCanActive = false
            clearInterval(self.timer)
          }
        }
      },

      // step3
      async toggleReport () {
        let self = this
        // eslint-disable-next-line
        let isGuideLink = (self.isLastGroup && self.$route.name === 'formal_exam') || (self.$route.name === 'practice_speaking') ? true : false

        if (self.ERS_arr.length === self.questionData.Questions.length) {
          if (self.$route.name === 'practice_speaking' && await self.checkSubmitReport(self.unitTitle, self.questionData.Name)) {
            self.finish_exams(self.$route.params.select_id, self.questionData.Name, isGuideLink)
          } else if (self.$route.name === 'formal_exam' && !self.isLastGroup) {
            self.$nextTick(() => {
              self.$emit('guideNextType')
            })
          } else if (self.$route.name === 'formal_exam' && self.isLastGroup) {
            self.post_gept_records_finish(self.$route.query.record_id)
          }
        }
      },

      isEmpty (obj) {
        return Object.keys(obj).length === 0
      },

      isNotEmpty (array) {
        let isNotEmptyFunc = (obj) => {
          return Object.keys(obj).length !== 0;
        }

        return array.every(isNotEmptyFunc)
      },

      reStart () {
        Object.assign(this.$data, this.$options.data())
      },

      setAudio (url) {
        let self = this
        if (url) {
          if (self.sound_effect) {
            const myName1 = () => {
              return new Promise(async(resolve) => {
                self.audio_stop()
                resolve('ok')
              })
            }

            Promise.race([myName1()])
            .then(() => {
              self.sound_effect = new Audio(url)

              self.audio_play()
            })
          } else {
            self.sound_effect = new Audio(url)

            self.audio_play()
          }
        }
      },

      audio_play () {
        let self = this

        self.sound_effect ? self.sound_effect.play() : null

        self.sound_effect.addEventListener('ended', () => {
          self.audio_stop()
        })
      },

      audio_stop () {
        let self = this

        self.sound_effect.pause()
        self.sound_effect.currentTime = 0
      }
    }
  }
</script>

<style lang="scss" scoped>
.read_sentences {
  .read_sentences_inner {
    .record-scuare {
      width: 10rem !important;
      @media (max-width: 640px) {
        width: 100% !important;
      }
      @media (min-width: 768px) {
          border-left: 8px solid #E3EcF1 !important;
      }
    }
    .col {
      flex: 1;
    }
    .item-outer2 {

    }
    .item-outer3 {
    }
    .active {

    }
    .play-voice {
      right: 10%;
      bottom: 10%;
      z-index: 2;
      @media (max-width: 1024px) {
        right: 0%;
        bottom: 0%;
      }
      @media (max-width: 640px) {
        right: 10%;
        bottom: 10%;
      }
    }
    .item_border_arrow_active{
      &:after {
        background-image: url('~@/assets/image/gept/arrow_active.jpg') !important;
      }
    }
    .item_img {
      min-height: 320px;
      .check {
        top: 45%;
        left: 50%;

        transform: translate(-50%, -50%);
      }
    }
    .item_text {
      min-height: 120px;
      height: 20%;
      @media (max-width: 1024px) {
        height: auto;
      }
    }
  }
}
</style>
